export default "__VITE_ASSET__CIGwTvpz__"